import { render, staticRenderFns } from "./index.vue?vue&type=template&id=275cab54"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('275cab54')) {
      api.createRecord('275cab54', component.options)
    } else {
      api.reload('275cab54', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=275cab54", function () {
      api.rerender('275cab54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/InnerLink/index.vue"
export default component.exports